import DrawerComponent from "@/components/DrawerComponent";
import { ActiveItemProvider } from "../home/context/ActiveItemContext";
import { SectionContainer } from "@/components/SectionContainer/SectionContainer";
import { DataGridLeands } from "./DataGrid";
import styles from "./Leads.module.css";
import {  CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { leadApi } from "@/services/api/leads";
import { CustomSnackbar } from "@/utils/alert";
import { LeadProvider, useLeads } from "./context/leadContext";
import attendantStorage from "@/utils/LocalStorage/attendant";
import { HeaderComponent } from "@/components/headerComponet";
import { CreateLeadModal } from "./ModalLeadCreate";
import { KanbanSearchBarPage } from "../kanban/KanbanSearchComponent";
import { KanbanSearchProvider, useKanbanSearch } from "../kanban/kanbanSearchContext/KanbanSearchContext";

type Severity = "success" | "error";

interface RegisterLead {
  name: string;
  phone: string;
  origin: string;
  stage: string;
  attendantId: string;
}

function LeandsPageContent() {
  const [selectedOptionJourneyStage, setSelectedOptionJourneyStage] = useState<string[]>([]); 
  const [selectedOptionOrigin, setSelectedOptionOrigin] = useState<string[]>([]); // Inicialize como array vazio

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [reload, setReload] = useState(false); // Controle de recarregamento
  const { fetchLeads, loading, addLeadCreated, leads, setLeads, leadsMemory} = useLeads(); 
  const [open, setOpen] = useState(false);

  const {searchTerm, selectedOptionAttendant, selectedOptionCreatedAt} = useKanbanSearch();


  const [alertInfo, setAlertInfo] = useState({
    severity: "success" as Severity,
    message: "",
  });
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    fetchLeads();
  }, []); 

  const onFilterRemove = (filter: string) => {
    console.log("Filtro removido:", filter);
    // Aqui você pode adicionar qualquer lógica adicional que deseja executar quando um filtro for removido
  };
  
  useEffect(() => {
    console.log("teste")
    let filteredLeads = leadsMemory;
  
    // Filtro por origem. A verificacao por tamanho é para garantir que o filtro seja aplicado apenas se houver opções selecionadas!
    if (selectedOptionOrigin.length > 0) { 
      filteredLeads = filteredLeads.filter((lead) =>
        selectedOptionOrigin.includes(lead.origem)
      );
    }
    
    // Filtro por data de criação
    if (selectedOptionCreatedAt) {
      const today = new Date();
      if (selectedOptionCreatedAt === "Hoje") {
        filteredLeads = filteredLeads.filter((lead) => {
          const leadDate = new Date(lead.createdAt);
          return (
            leadDate.getDate() === today.getDate() &&
            leadDate.getMonth() === today.getMonth() &&
            leadDate.getFullYear() === today.getFullYear()
          );
        });
      }
      if (selectedOptionCreatedAt === "Esta semana") {
        const currentDayOfWeek = today.getDay();
        const firstDayOfWeek = new Date(today);
        firstDayOfWeek.setDate(today.getDate() - (currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1));
        const lastDayOfWeek = new Date(today);
        lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
        filteredLeads = filteredLeads.filter((lead) => {
          const leadDate = new Date(lead.createdAt);
          return leadDate >= firstDayOfWeek && leadDate <= lastDayOfWeek;
        });
      }
      if (selectedOptionCreatedAt === "Este mês") {
        filteredLeads = filteredLeads.filter((lead) => {
          const leadDate = new Date(lead.createdAt);
          return (
            leadDate.getMonth() === today.getMonth() &&
            leadDate.getFullYear() === today.getFullYear()
          );
        });
      }
    }
    function normalizeDate(date:any) {
      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0); // Zera horas, minutos, segundos e milissegundos
      return normalizedDate;
    }

    if (startDate && endDate) {
      filteredLeads = filteredLeads.filter((lead) => {
        const leadDate = normalizeDate(new Date(lead.createdAt)); // Normalize a data do lead
        const normalizedStartDate = normalizeDate(startDate); // Normalize o startDate
        const normalizedEndDate = normalizeDate(endDate); // Normalize o endDate
        return leadDate >= normalizedStartDate && leadDate <= normalizedEndDate;
      });
    }

    // Filtro por atendente
    if (selectedOptionAttendant && selectedOptionAttendant.length > 0) {
      filteredLeads = filteredLeads.filter((lead) =>
        selectedOptionAttendant.includes(lead.Atendente?.id) // Use "lead.Atendente?.id" para comparar com os "id"s de atendentes selecionados
      );
    }
  
    // Filtro por etapa da jornada
    if (selectedOptionJourneyStage.length > 0) {
      filteredLeads = filteredLeads.filter((lead) =>
        selectedOptionJourneyStage.includes(lead.stage)
      );
    }
  
    // Filtro por nome (termo de busca)
    filteredLeads = filteredLeads.filter((lead) =>
      lead &&
      lead.nome?.toLowerCase().includes(searchTerm!.toLowerCase()) ||
      lead.telefone?.toLowerCase().includes(searchTerm!.toLowerCase()) ||
      lead.origem?.toLowerCase().includes(searchTerm!.toLowerCase()) ||
      lead.stage?.toLowerCase().includes(searchTerm!.toLowerCase()) ||
      lead.Atendente?.nome.toLowerCase().includes(searchTerm!.toLowerCase())
    );
  
    setLeads(filteredLeads);
  }, [
    selectedOptionOrigin,
    selectedOptionCreatedAt,
    selectedOptionAttendant,
    selectedOptionJourneyStage,
    searchTerm,
    startDate,
    leadsMemory // Adicione leadsMemory aqui para garantir que os filtros sejam aplicados aos leads atualizados
  ]);

  async function handleSaveLead(leadData: RegisterLead) {
    const attendant = attendantStorage.getToken();
    if (attendant) {
      leadData.attendantId = attendant.id;
      try {
        const response = await leadApi.create(leadData);
        if (response.status === 201) {
          addLeadCreated(response.data.response);
          setAlertInfo({
            severity: "success",
            message: "Lead criado com sucesso",
          });
          setShowAlert(true);
          setOpen(false);
        }
      } catch (error) {
        console.error("Erro ao criar lead:", error);
        setAlertInfo({
          severity: "error",
          message: "Erro ao criar lead",
        });
        setShowAlert(true);
      }
    }
  }

  function handleAlertClose() {
    setShowAlert(false);
  }

  return (
    <div className={styles.leadPage}>
      <HeaderComponent />
      <ActiveItemProvider>
        <DrawerComponent />
      </ActiveItemProvider>
      <CustomSnackbar
        open={showAlert}
        severity={alertInfo.severity}
        message={alertInfo.message}
        handleClose={handleAlertClose}
      />

      <div className={styles.headerSectionContainer}>
        <h3 className={`title-table ${styles.titleTable}`}>Leads</h3>
        <CreateLeadModal
          open={open}
          onClose={() => setOpen(false)}
          onSave={handleSaveLead}
          loading={loading}
        />
      </div>

      {loading ? (
        <div className={styles.spinnerContainer}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className={styles.sectionSearch}>
              <KanbanSearchBarPage 
                  selectedOptionOrigin={selectedOptionOrigin}
                  setSelectedOptionOrigin={setSelectedOptionOrigin}
                  selectedOptionJourneyStage={selectedOptionJourneyStage}
                  setSelectedOptionJourneyStage={setSelectedOptionJourneyStage}
                  startDate={startDate}
                  endDate={endDate}  
                  reload={reload}
                  setReload={setReload}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  onFilterRemove={onFilterRemove} // Passando a função onFilterRemove
                />
          </div>
          <SectionContainer margin="5rem">
            <DataGridLeands />
          </SectionContainer>
        </>
      )}
    </div>
  );
}


export function LeandsPage() {
  return (
    <LeadProvider>
      <KanbanSearchProvider>
        <LeandsPageContent />
      </KanbanSearchProvider>
    </LeadProvider>
  );
}
